import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { endOfMonth, format, startOfMonth } from 'date-fns';
import { useAuth } from '../../../auth/context/AuthProvider';

// Impor komponen V4
import StatsCardV4Component from './StatsCardV4Component';
import PieChartV4Component from './PieChartV4Component';

// Impor komponen lain yang masih relevan
// import OccupancyChartComponent from './OccupancyChartComponent';
import ReservationTableV4Component from './ReservationTableV4Component';
import OccupancyHighchartsComponent from './OccupancyHighchartsComponent';

const DashboardReportComponent: React.FC = () => {
    const { user } = useAuth();
    const [propertyId, setPropertyId] = useState<string>("");

    // Mengambil active_property_id dari user context saat sudah tersedia
    useEffect(() => {
        if (user) {
            setPropertyId(user.active_property_id || "");
        }
    }, [user]);

    // Logika untuk menentukan rentang tanggal bulan ini
    const now = new Date();
    const startDate = format(startOfMonth(now), 'yyyy-MM-dd');
    const endDate = format(endOfMonth(now), 'yyyy-MM-dd');

    // Tidak ada lagi logika fetching atau state management untuk chart di sini
    // Semua sudah dienkapsulasi di dalam komponen V4 masing-masing

    return (
        <Container fluid className="dashboard-content">
            {/* Komponen Statistik V4 */}
            <StatsCardV4Component
                property_id={propertyId}
                start_date={startDate}
                end_date={endDate}
            />

            {/* Komponen Pie Chart V4 */}
            <PieChartV4Component
                property_id={propertyId}
                start_date={startDate}
                end_date={endDate}
            />

            <ReservationTableV4Component
                property_id={propertyId}
                start_date={startDate}
                end_date={endDate}
            />

            {/* Komponen Occupancy Chart (tidak berubah) */}
            {/* <OccupancyChartComponent /> */}
            <OccupancyHighchartsComponent />
        </Container>
    );
};

export default DashboardReportComponent;